import AirDatepicker from "air-datepicker";
import localeEn from "air-datepicker/locale/en";
import "air-datepicker/air-datepicker.css";

document.addEventListener("DOMContentLoaded", function () {
	const searchEvents = document.querySelector("#search_events");

	function initEventFilters() {
		const searchMonth = document.querySelector("#search_month");
		const searchWeek = document.querySelector("#search_week");
		const startDateInput = document.querySelector("#start_date");
		const endDateInput = document.querySelector("#end_date");
		const ARTICLE_ITEM_SELECTOR =
			'.vp-wrapper.vp-story__item[data-type="article-section"]';

		// --- Config ---
		const SCROLL_ON_FILTER = true; // set false to disable smooth scroll
		const MOBILE_ONLY_PICKER = !!(window.VP?.helpers?.isMobile?.());
		const IS_TOUCH = ("ontouchstart" in window) || (navigator.maxTouchPoints > 0);
		const AUTO_CLOSE = true; // close picker on single selection (helps mobile)

		const $ = jQuery;

		let dpMin, dpMax;
		let startPickerOpen = false;
		let endPickerOpen = false;
		let settingQuickRange = false;
		let lastFilterKey = null;
		let programmaticScroll = false;
		let noResults = false;

		const NO_RESULTS_ID = "vp-no-results-msg";

		const showNoResultsMessage = () => {
			if (document.getElementById(NO_RESULTS_ID)) return; // already injected
			noResults = true;

			const firstTarget = document.querySelector(
				'.vp-filtered_events'
			);

			// outer wrapper
			const wrapper = document.createElement("div");
			wrapper.id = NO_RESULTS_ID;
			wrapper.className = "vp-wrapper";

			// inner module
			const msg = document.createElement("div");
			msg.className = "vp-module vp-no-results";

			// text
			const text = document.createElement("span");
			text.textContent = "No events were found in your specified dates. ";

			// clear link
			const link = document.createElement("a");
			link.href = "#";
			link.className = "vp-no-results__clear";
			link.textContent = "Clear dates";
			link.addEventListener("click", (e) => {
				e.preventDefault();
				clearStart();
				clearEnd();
			});

			msg.appendChild(text);
			msg.appendChild(link);
			wrapper.appendChild(msg);

			if (firstTarget) {
				firstTarget.parentNode.insertBefore(wrapper, firstTarget);
			} else {
				const container =
					document.querySelector(".vp-filtered_events") ||
					document.querySelector(".vp-wrapper");
				container?.appendChild(wrapper);
			}
		};

		const hideNoResultsMessage = () => {
			noResults = false;
			document.getElementById(NO_RESULTS_ID)?.remove();
		};

		// Guards for mobile picker
		let suppressHideOnScroll = false;
		let pickerJustOpened = false;

		const beginPickerOpen = () => {
			suppressHideOnScroll = true;
			pickerJustOpened = true;
			setTimeout(() => { suppressHideOnScroll = false; }, 320);
			setTimeout(() => { pickerJustOpened = false; }, 120);
		};

		const enforcePickerOnly = (input, picker) => {
			if (!input || !picker) return;
			input.setAttribute("readonly", "true");
			input.setAttribute("inputmode", "none");
			input.setAttribute("autocomplete", "off");
			input.setAttribute("aria-haspopup", "dialog");

			let openLock = false;
			const openPicker = (e) => {
				if (openLock) { e?.preventDefault?.(); e?.stopPropagation?.(); return; }
				openLock = true;
				setTimeout(() => { openLock = false; }, 220);

				e?.preventDefault?.();
				e?.stopPropagation?.();

				beginPickerOpen();
				picker.update({
					position: input === startDateInput
						? getStartDatepickerPosition()
						: getEndDatepickerPosition()
				});
				picker.show();
				setTimeout(() => input.blur(), 0);
			};

			input.onclick = null;
			input.onfocus = null;
			input.onpointerdown = null;
			input.ontouchend = null;

			if (IS_TOUCH) {
				input.addEventListener("touchend", openPicker, { passive: false });
			} else {
				input.addEventListener("click", openPicker);
				input.addEventListener("focus", openPicker);
			}
		};

		const clearQuickActive = () => {
			searchMonth?.classList.remove("active");
			searchWeek?.classList.remove("active");
		};

		// --- debounce & timing ---
		const debounce = function (fn, wait = 80) {
			let t;
			return function (...args) {
				clearTimeout(t);
				const ctx = this;
				t = setTimeout(() => fn.apply(ctx, args), wait);
			};
		};
		const MEASURE_DELAY_MS = 100;

		// ----- Helpers -----
		const pad2 = (n) => String(n).padStart(2, "0");
		const toISO = (d) =>
			`${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
		const normalizeLocal = (d) =>
			new Date(d.getFullYear(), d.getMonth(), d.getDate());

		const MIN_OPEN = new Date(-8640000000000000);
		const MAX_OPEN = new Date(8640000000000000);
		const MIN_CAL = new Date(1900, 0, 1);
		const MAX_CAL = new Date(2100, 11, 31);

		const rangesOverlap = (aStart, aEnd, bStart, bEnd) => {
			const Astart = aStart || MIN_OPEN;
			const Aend = aEnd || MAX_OPEN;
			const Bstart = bStart || MIN_OPEN;
			const Bend = bEnd || MAX_OPEN;
			return Astart <= Bend && Aend >= Bstart;
		};

		const today = normalizeLocal(new Date());

		const parseTypedDate = (str) => {
			if (!str) return null;
			const s = str.trim().replace(/-/g, "/");
			const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
			if (!m) return null;
			let [, mm, dd, yy] = m;
			const month = +mm, day = +dd;
			const yNum = Number(yy);
			const year = yy.length === 2 ? (yNum >= 70 ? 1900 + yNum : 2000 + yNum) : +yy;
			const d = new Date(year, month - 1, day);
			return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day ? d : null;
		};

		const parseYMDLocal = (str) => {
			const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str || "");
			if (!m) return null;
			const y = +m[1], mo = +m[2], d = +m[3];
			return new Date(y, mo - 1, d); // local midnight
		};

        const getItemRange = (el) => {
            const sAttr = el.getAttribute("data-start") || "";
            const eAttr = el.getAttribute("data-end") || "";
            const s = sAttr ? parseYMDLocal(sAttr) : null;
            const e = eAttr ? parseYMDLocal(eAttr) : null;
            const start = s && !isNaN(s) ? s : null;
            const end = e && !isNaN(e) ? e : start;

            const modeRaw = (el.getAttribute("data-date-mode") || "standard").toLowerCase();
            const mode = (modeRaw === "include" || modeRaw === "exclude") ? modeRaw : "standard";

            const datesAttr = el.getAttribute("data-dates") || "";
            const dates = datesAttr
                .split(",")
                .map((x) => x.trim())
                .filter(Boolean)
                .map(parseYMDLocal)
                .filter((d) => d && !isNaN(d))
                .map(normalizeLocal);

            // Set of local-midnight timestamps for O(1) lookups
            const dateSet = new Set(dates.map((d) => d.getTime()));

            return { start, end, mode, dateSet };
        };


		const hideNode = (el) => {
			el.classList.add("is-hidden");
			el.style.display = "none";
		};
		const showNode = (el) => {
			el.classList.remove("is-hidden");
			el.style.display = "";
			$(el).find(".js-reveal").css("opacity", 1);
		};

		const updateBreakers = () => {
			const breakers = document.querySelectorAll(
				'.vp-wrapper.vp-story__item[data-type="breaker"]'
			);
			breakers.forEach((br) => {
				let sib = br.nextElementSibling;
				let hasVisibleArticle = false;
				while (sib) {
					if (sib.matches('.vp-wrapper.vp-story__item[data-type="breaker"]')) break;
					if (sib.matches('.vp-wrapper.vp-story__item[data-type="article-section"]')) {
						if (!sib.classList.contains("is-hidden")) { hasVisibleArticle = true; break; }
					}
					sib = sib.nextElementSibling;
				}
				hasVisibleArticle ? showNode(br) : hideNode(br);
			});
		};

		const disableOldDays = (startDate, endDate) => {
			const listItems = $(".vp-wysiwyg ul li");
			listItems.removeClass("disabled");
			listItems.each(function () {
				const li = $(this);
				const match = li.text().match(/\(([^()]*\b\d{4})\)$/);
				if (match) {
					const rawDateStr = match[1].replace(/(\d{1,2})(st|nd|rd|th)/g, "$1");
					const rangeMatch = rawDateStr.match(/([A-Za-z]+)\s+(\d{1,2})[\u2013\-](\d{1,2}),\s*(\d{4})/);
					if (rangeMatch) {
						const [, month, , endDay, year] = rangeMatch;
						const eventEnd = normalizeLocal(new Date(`${month} ${endDay}, ${year}`));
						if (eventEnd < startDate || eventEnd > endDate) li.addClass("disabled");
					} else {
						const d = normalizeLocal(new Date(rawDateStr));
						if (d < startDate || d > endDate) li.addClass("disabled");
					}
				}
			});
		};

        const formatInputValue = (input, placeholder, date) => {
            if (!input) return;
            if (date instanceof Date && !isNaN(date)) {
                try {
                    const formatted = dpMin?.formatDate
                        ? dpMin.formatDate(date, "MM/dd/yyyy")
                        : date.toLocaleDateString("en-US");
                    input.value = formatted;
                } catch {
                    input.value = date.toLocaleDateString("en-US");
                }
            } else {
                input.value = "";
            }
            input.placeholder = `${placeholder}`;

            // toggle clear button visibility via wrapper class
            const wrap = input.closest(".dp-wrap");
            if (wrap) wrap.classList.toggle("has-value", !!input.value);
        };


		const markInvalid = (el, on) => el && el.classList.toggle("is-invalid", !!on);

		const isPickerOpen = (dp) =>
			!!(dp?.$datepicker && dp.$datepicker.classList.contains("-active-"));
		const safeHide = (dp) => {
			if (!dp) return;
			try {
				if (isPickerOpen(dp)) dp.hide();
			} catch (_) {}
		};

		const clearStart = () => {
			clearQuickActive();
			dpMin?.clear();
			dpMax?.update({ minDate: MIN_CAL });
			formatInputValue(startDateInput, "From", null);
			doFilter();
		};

		const clearEnd = () => {
			clearQuickActive();
			dpMax?.clear();
			formatInputValue(endDateInput, "To", null);
			doFilter();
		};

		const handleManualInput = (which) => {
			const input = which === "start" ? startDateInput : endDateInput;
			if (!input) return;
			const raw = (input.value || "").trim();
			if (!raw) return;
			const d = parseTypedDate(raw);
			markInvalid(input, !!raw && !d);
		};

		const commitTypedDate = (which) => {
			if ((which === "start" && startPickerOpen) || (which === "end" && endPickerOpen)) return;

			const input = which === "start" ? startDateInput : endDateInput;
			const dp = which === "start" ? dpMin : dpMax;
			const other = which === "start" ? dpMax : dpMin;
			if (!input) return;

			const raw = (input.value || "").trim();
			if (!raw) { which === "start" ? clearStart() : clearEnd(); return; }

			const d = parseTypedDate(raw);
			if (!d) { markInvalid(input, true); return; }

			clearQuickActive();
			if (which === "start") other?.update({ minDate: d });
			dp?.selectDate(d);
			markInvalid(input, false);
		};

		if (!MOBILE_ONLY_PICKER) {
			startDateInput?.addEventListener("input", () => handleManualInput("start"));
			endDateInput?.addEventListener("input", () => handleManualInput("end"));
			startDateInput?.addEventListener("blur", () => commitTypedDate("start"));
			endDateInput?.addEventListener("blur", () => commitTypedDate("end"));

			startDateInput?.addEventListener("keydown", (e) => {
				if (e.key === "Enter") { e.preventDefault(); commitTypedDate("start"); }
				if (e.key === "Escape") { e.preventDefault(); clearStart(); }
			});
			endDateInput?.addEventListener("keydown", (e) => {
				if (e.key === "Enter") { e.preventDefault(); commitTypedDate("end"); }
				if (e.key === "Escape") { e.preventDefault(); clearEnd(); }
			});
		}

		const hasExpandedMap = () => document.body.classList.contains("expandedmap");

		const getStartDatepickerPosition = () => (window.innerWidth <= 768 ? "top left" : "bottom left");
		const getEndDatepickerPosition = () => {
			if (hasExpandedMap()) return "bottom right";
			return window.innerWidth <= 768 ? "top right" : "bottom left";
		};

		const disableBodyScroll = () => {
			if (window.innerWidth <= 768) document.body.style.overflow = "hidden";
		};
		const enableBodyScroll = () => (document.body.style.overflow = "");
		const NAV_TITLES_NO_COMMA = { days: (dp) => dp.formatDate(dp.viewDate, "MMMM yyyy") };

		// --- scroll helpers ---
		const getFirstVisibleAnchor = () =>
			document.querySelector(
				'.vp-wrapper.vp-story__item[data-type="article-section"]:not(.is-hidden), ' +
				'.vp-wrapper.vp-story__item[data-type="breaker"]:not(.is-hidden)'
			) || document.getElementById(NO_RESULTS_ID);

		const queuedSmoothScroll = () => {
			// wait for DOM changes to apply (display:none, heights) before measuring
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					computeContentEnd();
					updateStickyState();
					smoothScrollToListTop();
				});
			});
		};

		// datepickers
		dpMin = new AirDatepicker(startDateInput, {
			locale: localeEn,
			navTitles: NAV_TITLES_NO_COMMA,
			minDate: MIN_CAL,
			maxDate: MAX_CAL,
			position: getStartDatepickerPosition(),
			autoClose: AUTO_CLOSE,
			clearButton: true,
			buttons: ["clear"],
			onSelect({ date, datepicker }) {
				if (!settingQuickRange) clearQuickActive();

				let changedEnd = false;
				if (date) {
					// ensure end >= start, but don't create an end if empty
					dpMax?.update({ minDate: date });
					const currentEndRaw = dpMax?.selectedDates?.[0] || null;
					if (currentEndRaw && normalizeLocal(currentEndRaw) < normalizeLocal(date)) {
						changedEnd = true;
						dpMax.selectDate(date);
					}
				} else {
					dpMax?.update({ minDate: MIN_CAL });
				}

				formatInputValue(startDateInput, "From", date || null);
				if (datepicker?.$datepicker?.classList.contains("-active-")) { datepicker.hide(); }

				if (!changedEnd) {
					doFilter();
				}
			},
			onShow() {
				startPickerOpen = true;
				beginPickerOpen();
				dpMin.update({ position: getStartDatepickerPosition() });
				disableBodyScroll();
				if (dpMax && dpMax.$datepicker?.classList.contains("-active-")) dpMax.hide();
			},
			onHide() {
				startPickerOpen = false;
				enableBodyScroll();
			}
		});

		dpMax = new AirDatepicker(endDateInput, {
			locale: localeEn,
			navTitles: NAV_TITLES_NO_COMMA,
			minDate: MIN_CAL,
			maxDate: MAX_CAL,
			position: getEndDatepickerPosition(),
			autoClose: AUTO_CLOSE,
			clearButton: true,
			buttons: ["clear"],
			onSelect({ date, datepicker }) {
				if (!settingQuickRange) clearQuickActive();
				formatInputValue(endDateInput, "To", date || null);
				if (datepicker?.$datepicker?.classList.contains("-active-")) { datepicker.hide(); }
				doFilter();
			},
			onShow() {
				endPickerOpen = true;
				beginPickerOpen();
				dpMax.update({ position: getEndDatepickerPosition() });
				disableBodyScroll();
				if (dpMin && dpMin.$datepicker?.classList.contains("-active-")) dpMin.hide();
			},
			onHide() {
				endPickerOpen = false;
				enableBodyScroll();
			}
		});
        
        // --- clear buttons (start/end) ---
        const startWrap = startDateInput?.closest(".dp-wrap");
        const endWrap = endDateInput?.closest(".dp-wrap");
        const startClearBtn = startWrap?.querySelector(".dp-close");
        const endClearBtn = endWrap?.querySelector(".dp-close");

        // one activation event that won't double-fire
        const CLEAR_ACTIVATE_EVT = window.PointerEvent
            ? "pointerup"
            : ("ontouchend" in window ? "touchend" : "click");

        const syncClearVisibility = () => {
            if (startWrap) startWrap.classList.toggle("has-value", !!startDateInput?.value);
            if (endWrap) endWrap.classList.toggle("has-value", !!endDateInput?.value);
        };

        // keep buttons from focusing inputs
        if (window.PointerEvent) {
            startClearBtn?.addEventListener("pointerdown", (e) => e.preventDefault(), { passive: false });
            endClearBtn?.addEventListener("pointerdown", (e) => e.preventDefault(), { passive: false });
        } else if ("ontouchstart" in window) {
            startClearBtn?.addEventListener("touchstart", (e) => e.preventDefault(), { passive: false });
            endClearBtn?.addEventListener("touchstart", (e) => e.preventDefault(), { passive: false });
        }

        // handlers
        const handleClearStart = (e) => {
            e.preventDefault();
            e.stopPropagation();
            clearStart();
            startDateInput?.blur();
            syncClearVisibility();
        };
        const handleClearEnd = (e) => {
            e.preventDefault();
            e.stopPropagation();
            clearEnd();
            endDateInput?.blur();
            syncClearVisibility();
        };

        // attach exactly one activation listener per button
        startClearBtn?.addEventListener(CLEAR_ACTIVATE_EVT, handleClearStart, { passive: false });
        endClearBtn?.addEventListener(CLEAR_ACTIVATE_EVT, handleClearEnd, { passive: false });

        // keep in sync while typing (desktop)
        startDateInput?.addEventListener("input", syncClearVisibility);
        endDateInput?.addEventListener("input", syncClearVisibility);

        // initial sync
        syncClearVisibility();


		if (MOBILE_ONLY_PICKER) {
			enforcePickerOnly(startDateInput, dpMin);
			enforcePickerOnly(endDateInput, dpMax);
		}

		startDateInput?.addEventListener("click", (e) => {
			e.preventDefault();
			beginPickerOpen();
			dpMin.update({ position: getStartDatepickerPosition() });
			dpMin.show();
		});
		endDateInput?.addEventListener("click", (e) => {
			e.preventDefault();
			beginPickerOpen();
			dpMax.update({ position: getEndDatepickerPosition() });
			dpMax.show();
		});

		const closeDatepickers = () => { safeHide(dpMin); safeHide(dpMax); };

		// Outside-click close — ignore the immediate click after opening
		document.addEventListener("click", (e) => {
			if (pickerJustOpened) return;
			if (!(startPickerOpen || endPickerOpen)) return;

			const t = e.target;
			const insidePicker = !!t.closest(".air-datepicker");
			const insideStart = !!t.closest("#start_date");
			const insideEnd = !!t.closest("#end_date");
			if (insidePicker || insideStart || insideEnd) return;

			setTimeout(closeDatepickers, 0);
		});

		// ----- Quick ranges
		searchMonth?.addEventListener("click", () => {
			const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
			settingQuickRange = true;
			dpMin.selectDate(today);
			dpMax.selectDate(lastDay);
			setTimeout(() => {
				searchMonth.classList.add("active");
				searchWeek?.classList.remove("active");
				settingQuickRange = false;
			}, 0);
		});

		searchWeek?.addEventListener("click", () => {
			const dow = today.getDay();
			const daysUntilSunday = 7 - dow;
			const sun = new Date(today.getFullYear(), today.getMonth(), today.getDate() + daysUntilSunday);
			settingQuickRange = true;
			dpMin.selectDate(today);
			dpMax.selectDate(sun);
			setTimeout(() => {
				searchWeek.classList.add("active");
				searchMonth?.classList.remove("active");
				settingQuickRange = false;
			}, 0);
		});

		// Manual search: commit typed values first (if pickers not open)
		searchEvents?.addEventListener("click", () => {
			commitTypedDate("start");
			commitTypedDate("end");
			doFilter();
		});

		// Track bottom of last visible article-section
		let CONTENT_END_Y = 0;
		const computeContentEnd = () => {
			const items = Array.from(document.querySelectorAll(ARTICLE_ITEM_SELECTOR))
				.filter(el => !el.classList.contains("is-hidden"));
			if (!items.length) { CONTENT_END_Y = 0; return; }
			const last = items[items.length - 1];
			const rect = last.getBoundingClientRect();
			CONTENT_END_Y = rect.bottom + (window.scrollY || window.pageYOffset);
		};

		const stickyEl =
			document.querySelector(".vp-dates.vp-wrapper") ||
			document.querySelector(".vp-dates.vp.wrapper");

		const FIXED_TOP = 75;
		let originalTop = 0;
		const isMobile = () => window.innerWidth <= 768;

		// --- sticky settle control ---
		let stickyReady = false;
		let lastWidth = 0, lastLeft = 0, lastTop = 0, stableHits = 0;
		const STABLE_EPS = 2; // px tolerance
		let bootTimerIds = [];

		const measureSticky = () => {
			if (!stickyEl) return;

			// keep it out of view while settling
			if (!stickyReady) {
				stickyEl.style.position = "relative";
				stickyEl.style.visibility = "hidden";
				stickyEl.style.removeProperty("--stick-left");
				stickyEl.style.removeProperty("--stick-width");
			}

			setTimeout(() => {
				const rect = stickyEl.getBoundingClientRect();
				const top = rect.top + window.scrollY;
				const left = rect.left;
				const width = rect.width;

				// lock metrics
				stickyEl.style.setProperty("--stick-left", `${left}px`);
				stickyEl.style.setProperty("--stick-width", `${width}px`);

				// also measure where the visible content ends
				computeContentEnd();

				// stability check
				const sameW = Math.abs(width - lastWidth) <= STABLE_EPS;
				const sameL = Math.abs(left - lastLeft) <= STABLE_EPS;
				const sameT = Math.abs(top - lastTop) <= STABLE_EPS;

				stableHits = (sameW && sameL && sameT) ? (stableHits + 1) : 0;
				lastWidth = width;
				lastLeft = left;
				lastTop = top;

				// update threshold top AFTER stabilization math
				originalTop = top;

				if (!stickyReady && stableHits >= 2) {
					stickyReady = true;
					stickyEl.style.position = "";
					stickyEl.style.visibility = ""; // show
					bootTimerIds.forEach(clearTimeout);
					bootTimerIds = [];
					updateStickyState();
				} else if (stickyReady) {
					updateStickyState();
				}
			}, MEASURE_DELAY_MS);
		};

		// run measureSticky several times as the page settles
		const LAYOUT_SETTLE_STEPS = [0, 120, 300, 700, 1500];
		const bootMeasureSticky = () => {
			bootTimerIds.forEach(clearTimeout);
			bootTimerIds = [];
			LAYOUT_SETTLE_STEPS.forEach((ms) => {
				bootTimerIds.push(setTimeout(measureSticky, ms));
			});
			if (document.fonts?.ready) {
				document.fonts.ready.then(() => {
					bootTimerIds.push(setTimeout(measureSticky, 0));
				});
			}
		};

		const updateStickyState = () => {
			if (!stickyEl || !stickyReady) return;

			// disable sticky entirely when no results are showing
			if (noResults) {
				stickyEl.classList.remove("sticky-top", "sticky-bottom", "visible");
				return;
			}

			// don't let sticky toggle during programmatic scroll
			if (programmaticScroll) return;

			// Close any open pickers when scrolling, unless we just opened one
			if (!suppressHideOnScroll) {
				safeHide(dpMin);
				safeHide(dpMax);
			}

			const scrollTop = window.scrollY || window.pageYOffset;

			// Past end of content? remove sticky
			if (CONTENT_END_Y > 0) {
				const thresholdY = isMobile()
					? (scrollTop + window.innerHeight)
					: (scrollTop + FIXED_TOP);
				if (thresholdY >= CONTENT_END_Y) {
					stickyEl.classList.remove("sticky-top", "sticky-bottom", "visible");
					return;
				}
			}

			if (isMobile()) {
				stickyEl.classList.remove("sticky-top");
				const threshold = 400;
				if (scrollTop > threshold) {
					stickyEl.classList.add("sticky-bottom", "visible");
				} else {
					stickyEl.classList.remove("sticky-bottom", "visible");
				}
			} else {
				stickyEl.classList.remove("sticky-bottom", "visible");
				if (scrollTop + FIXED_TOP >= originalTop) {
					stickyEl.classList.add("sticky-top");
				} else {
					stickyEl.classList.remove("sticky-top");
				}
			}
		};

		const smoothScrollToListTop = () => {
			if (!SCROLL_ON_FILTER) return;

			const firstItem = getFirstVisibleAnchor();
			if (!firstItem) return;

			// measure sticky height once
			const stickyRect = stickyEl ? stickyEl.getBoundingClientRect() : null;
			const stickyHeight = stickyRect ? stickyRect.height : 0;
			const offset = Math.max(stickyHeight + 140, 0);
            console.log(stickyHeight, offset);

			const targetY = Math.max(
				firstItem.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - offset,
				0
			);

			// freeze sticky while we animate so layout doesn't shift mid-flight
			programmaticScroll = true;

			$("html, body")
				.stop(true, false)
				.animate(
					{ scrollTop: targetY },
					420,
					"swing",
					() => {
						programmaticScroll = false;
						updateStickyState(); // sync sticky to final position
					}
				);
		};

		const doFilter = () => {
			const selStartRaw = dpMin?.selectedDates?.[0] || null;
			const selEndRaw = dpMax?.selectedDates?.[0] || null;
			const selStart = selStartRaw ? normalizeLocal(selStartRaw) : null;
			const selEnd = selEndRaw ? normalizeLocal(selEndRaw) : null;

			const items = document.querySelectorAll(ARTICLE_ITEM_SELECTOR);
			const key = `${selStart ? toISO(selStart) : ""}|${selEnd ? toISO(selEnd) : ""}`;
			const filterActive = !!(selStart || selEnd);

			if (!filterActive) {
				items.forEach(showNode);
				updateBreakers();
				jQuery(".vp-wysiwyg ul li").removeClass("disabled");
				document.querySelectorAll(".vp-related-first__panel").forEach(showNode);

				window.dispatchEvent(
					new CustomEvent("vp:articles:filtered", {
						detail: {
							textIds: Array.from(
								document.querySelectorAll(`${ARTICLE_ITEM_SELECTOR} .vp-article-section`)
							)
								.map((n) => n?.dataset?.textid)
								.filter(Boolean),
						},
					})
				);

				if (lastFilterKey !== key && lastFilterKey !== null) queuedSmoothScroll();
				lastFilterKey = key;

				// recompute end and sticky after visibility change
				computeContentEnd();
				updateStickyState();
				VP.reveal.updatePosition();
				hideNoResultsMessage();
				return;
			}

			// When filtering…
			const bStart = selStart || MIN_OPEN;
			const bEnd = selEnd || MAX_OPEN;
			const visibleTextIds = [];
			document.querySelectorAll(".vp-related-first__panel").forEach(hideNode);

            items.forEach((el) => {
                const { start, end, mode, dateSet } = getItemRange(el);

                // If the item has no dates at all (and no special list), hide it when filtering
                if (!start && !end && mode === "standard" && dateSet.size === 0) {
                    hideNode(el);
                    return;
                }

                let visible = false;

                if (mode === "standard") {
                    // Original behavior: any overlap of ranges shows the item
                    visible = rangesOverlap(start, end, bStart, bEnd);

                } else if (mode === "include") {
                    // Only dates explicitly listed are valid.
                    // Show if any listed date falls within the user's selected window
                    // AND (optionally) within the item's own start/end window.
                    if (dateSet.size > 0) {
                        for (const t of dateSet) {
                            const d = new Date(t); // local midnight
                            // Constrain to item window to match "subset of range above"
                            if (start && d < start) continue;
                            if (end && d > end) continue;

                            if (bStart <= d && d <= bEnd) { visible = true; break; }
                        }
                    }

                } else if (mode === "exclude") {
                    // Baseline is the full start..end range, but remove listed dates.
                    // If the baseline doesn't overlap the selection at all, hidden.
                    if (rangesOverlap(start, end, bStart, bEnd)) {
                        const os = normalizeLocal(new Date(Math.max(
                            start ? start.getTime() : MIN_OPEN.getTime(),
                            bStart.getTime()
                        )));
                        const oe = normalizeLocal(new Date(Math.min(
                            end ? end.getTime() : MAX_OPEN.getTime(),
                            bEnd.getTime()
                        )));

                        // If nothing is excluded, any overlapping day is enough.
                        if (dateSet.size === 0) {
                            visible = true;
                        } else {
                            // Walk the overlapping days until we find one NOT excluded.
                            let cur = os;
                            while (cur <= oe) {
                                if (!dateSet.has(cur.getTime())) { visible = true; break; }
                                cur = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + 1);
                            }
                        }
                    }
                }

                if (visible) {
                    showNode(el);
                    const tid = el.querySelector(".vp-article-section")?.dataset?.textid;
                    if (tid) visibleTextIds.push(tid);
                } else {
                    hideNode(el);
                }
            });


			updateBreakers();
			disableOldDays(bStart, bEnd);

			window.dispatchEvent(
				new CustomEvent("vp:articles:filtered", { detail: { textIds: visibleTextIds } })
			);

			if (lastFilterKey !== key && lastFilterKey !== null) queuedSmoothScroll();
			lastFilterKey = key;

			// Check if any article-sections are still visible
			const anyVisible = Array.from(document.querySelectorAll(ARTICLE_ITEM_SELECTOR))
				.some(el => !el.classList.contains("is-hidden"));

			if (anyVisible) {
				hideNoResultsMessage();
			} else {
				showNoResultsMessage();
			}

			// Recompute end of content & re-evaluate sticky after filtering
			computeContentEnd();
			updateStickyState();
			VP.reveal.updatePosition();
		};  // end doFilter

		// --- Events / boot ---
		const debouncedMeasureSticky = debounce(measureSticky, 120);

		window.addEventListener("scroll", updateStickyState, { passive: true });

		window.addEventListener("resize", () => {
			if (!suppressHideOnScroll) {
				safeHide(dpMin);
				safeHide(dpMax);
			}
			debouncedMeasureSticky();
		});
		window.addEventListener("orientationchange", debouncedMeasureSticky, { passive: true });

		// staged measurements after full load
		window.addEventListener("load", bootMeasureSticky);
		// also kick once soon after DOM is ready
		setTimeout(measureSticky, 0);

		// ----- Initial render (empty => show all)
		formatInputValue(startDateInput, "From", null);
		formatInputValue(endDateInput, "To", null);

		document.querySelectorAll(ARTICLE_ITEM_SELECTOR).forEach((el) => getItemRange(el));
		doFilter();
	}

	if (searchEvents) {
		initEventFilters();
	}
});
